// This class contains the necessary method of gathering plan data for the policy replacement form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class PolicyReplacementForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [
			...this.getProposedInsuredMapping(),
			...this.getFuneralHomeRepresentativeMappings(),
			...this.getProposedInsuredAddressMapping(),
			...this.getFuneralHomeMapping(),
		]
	}
}
